import React from "react";

const PageFooter = ({ children }) => {
  return (
    <div className="page-footer">
      <div className="container bg-white">
        <div className="page-container text-center">{children}</div>
      </div>
    </div>
  );
};

export default PageFooter;
